import { useEffect, useMemo, useState } from 'react';
import { motion } from 'framer-motion';

export const ranges = [
  { label: '1H', value: 1, unit: 'hour' },
  { label: '24H', value: 24, unit: 'hour' },
  { label: '7D', value: 7, unit: 'day' },
];

function formatDate(date) {
  return date.toLocaleDateString('en-GB');
}

export default function TimeRangeSelector({ value = ranges[1], onChange }) {
  const [selected, setSelected] = useState(value);
  useEffect(() => setSelected(value), [value]);

  const rangeText = useMemo(() => {
    const end = new Date();
    const start = new Date(end);
    if (selected.unit === 'hour') {
      start.setHours(end.getHours() - selected.value);
    } else {
      start.setDate(end.getDate() - selected.value);
    }
    return `${formatDate(start)} - ${formatDate(end)}`;
  }, [selected]);

  const handleSelect = (r) => {
    setSelected(r);
    onChange && onChange(r);
  };

  return (
    <div className="flex flex-col items-end gap-2 text-right">
      <div className="relative flex gap-1 rounded-full border border-white/20 bg-white/10 p-1 backdrop-blur-xl transition dark:border-white/10 dark:bg-white/5">
        {ranges.map((r) => (
          <button
            key={r.label}
            onClick={() => handleSelect(r)}
            className="relative flex-1 overflow-hidden rounded-full px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.3em] text-slate-400 transition-colors hover:text-slate-200 dark:text-slate-300"
          >
            {selected.label === r.label && (
              <motion.span
                layoutId="active-pill"
                className="absolute inset-0 rounded-full bg-gradient-to-r from-emerald-400 via-sky-400 to-blue-500 shadow-lg shadow-emerald-500/30"
                transition={{ type: 'spring', stiffness: 320, damping: 28 }}
              />
            )}
            <span
              className={`relative z-10 transition-colors ${
                selected.label === r.label
                  ? 'text-emerald-950'
                  : 'text-slate-500 dark:text-slate-300'
              }`}
            >
              {r.label}
            </span>
          </button>
        ))}
      </div>
      <motion.div
        key={rangeText}
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="text-[11px] font-medium uppercase tracking-[0.3em] text-slate-400 dark:text-slate-500"
      >
        {rangeText}
      </motion.div>
    </div>
  );
}
